import React, { useState } from "react";
import NavBar from "../../../components/organisms/navbar";
import Footer from "../../../components/organisms/footer";
import {
  Container,
  Content,
  TournamentActions,
  TournamentDescription,
} from "../styles";

const InstrucaoTesteConnectPagbank: React.FC = () => {
  return (
    <>
      <NavBar />
      <Container>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>INSTRUÇÃO PARA TESTE DE CONEXÃO DE CONTA</h1>
              <ol>
                <li>
                  Como estamos em ambiente de teste, é necessário que você faça previamente o seu login no sandbox do pagbank <a href="https://portaldev.pagbank.com.br/" target="_blank">https://portaldev.pagbank.com.br/</a>
                </li>
                <br />
                <li>
                  Acesse: <a href="https://s1.hmg.torneiofacil.com/login" target="_blank" rel="noopener noreferrer">https://s1.hmg.torneiofacil.com./login</a><br />
                  Usuário: m4rciete@gmail.com<br />
                  Senha: TestePagSeguro123@
                </li>
                <br />
                <li>
                  Cadastre sua conta do banco pagbank em nossa plataforma: <a href="https://s1.hmg.torneiofacil.com/tournament/connect-bank" target="_blank" rel="noopener noreferrer">https://s1.hmg.torneiofacil.com/tournament/connect-bank</a>
                </li>
                <br />
                <li>
                  Clique no botão "Cadastrar banco", digite um nome e uma descricao, depois clique em "Cadastrar banco"
                </li>
                <br />
                <li>Ao criar a conta, você será redirecionado à página do pagbank para autorizar a autenticação de sua conta!</li>
                <br />
                <li>Depois de autorizar sua conta, você será redirecionado para o site do Torneio Fácil, onde o sistema valida suas informações, de acordo com o id e o código retornado do pagbank</li>
                <br />
                <li>Se a validação for aceita aparecerá uma página informando a mensagem: "Conta validada com sucesso!", clique no botão "Retorna a pagina inicial"</li>
                <br />
                <li>Vá em: <a href="https://s1.hmg.torneiofacil.com/tournament/connect-bank" target="_blank" rel="noopener noreferrer">https://s1.hmg.torneiofacil.com/tournament/connect-bank</a></li>
                <br />
                <li>Clique no botão: Vincular Conta ao torneio</li>
                <br />
                <li>Escolha um torneio para vincular, uma conta de banco e clique em editar</li>
                <br />
                <li>Neste processo, o sistema vincula sua conta de banco no torneio selecionado</li>
                <br />
                <li>Agora, quando um checkout é gerado, o sistema utiliza o token do cliente, fornecido pelo pagbank.</li>

                <h1 style={{ textAlign: "center" }}>INSTRUÇÃO PARA TESTE DE PAGAMENTO COM API ORDERS</h1>
                <li>
                  Para fazer e pagar uma inscrição acesse: <a href="https://s1.hmg.torneiofacil.com/enrollment/copa-cianorte-de-jiu-jitsu-2025-cianorte-pr-gi" target="_blank" rel="noopener noreferrer">link para inscrição</a>
                </li>
                <br />
                <li>Na opção: Escolha um atleta para esse evento</li>
                <br />
                <li>Selecione a opção MARCIETE FERNADES DELLARMELINA</li>
                <br />
                <li>Marque TODOS os checkboxes para confirmar seus dados</li>
                <br />
                <li>Selecione o tipo de inscricao, marque a opção "GI"</li>
                <br />
                <li>Escolha uma categoria</li>
                <br />
                <li>Escolha um Peso</li>
                <br />
                <li>Escolha a opção de "Pessoa com deficiência - PCD"</li>
                <br />
                <li>Clique em INSCREVER. Nesse momento você será redirecionado para o ambiente de pagamento de teste</li>
                <br />
                <li>Após o pagamento é possivel conferir o status da inscrição em: <a href="https://s1.hmg.torneiofacil.com/profile/subscription" target="_blank" rel="noopener noreferrer">https://s1.hmg.torneiofacil.com/profile/subscription</a> </li>
              </ol>
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default InstrucaoTesteConnectPagbank;
